import React, { useEffect } from "react";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import { useTranslation } from 'react-i18next';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

/**
 * @Description this page Active Directory  Library's Delete Computer  Action's configuration form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     div element
 * @Author      Abdullah Onur Yeşil
 */
export default function MoveComputer({
    action,
    variables,
    setOpenVariable,
}) {
    const { t } = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.ACTIVE-DIRECTORY.DELETE-COMPUTER.";

    return (
        <div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + "COMPUTER-CN")} is_required={true} />
                <TextInput
                    action={action}
                    inputName="cn"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired={true}
                    fieldType="string"
                    displayName={t(label + "COMPUTER-CN")}
                    hideRequired={true}
                />
                <small className='conf-field-desc'>computer1</small>
            </div>

        </div>
    );
}
